import { guideDo, guideStats, mythItems } from "@/mocks/home";

export default function Guide() {
  return (
    <section id="guide" className="border-t border-background-200 bg-background-50 py-10 md:py-14">
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 md:grid-cols-12 md:px-6">
        {/* 左：避雷四步 */}
        <div className="md:col-span-7">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-200 text-secondary-900">
              <i className="ri-shield-check-line text-lg" />
            </span>
            <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">避雷指南</h3>
          </div>
          <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
            吃瓜补课不踩坑的四个习惯。把「看热闹」变成「看得懂」，先学会给证据分级，再决定要不要站队。
          </p>

          <div className="mt-6 flex flex-col gap-4">
            {guideDo.map((d) => (
              <div key={d.key} className="flex gap-4 rounded-lg bg-background-100 p-4 sm:p-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-lg font-bold text-primary-700">
                  {d.key}
                </span>
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h4 className="text-base font-semibold text-foreground-950">{d.title}</h4>
                    <span className="whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-900">
                      {d.tag}
                    </span>
                  </div>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{d.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 右：数据高亮 + 破除误区 */}
        <div className="flex flex-col gap-6 md:col-span-5">
          <div className="rounded-lg bg-background-100 p-5">
            <p className="text-sm font-semibold text-foreground-950">补课档案（持续累积）</p>
            <div className="mt-4 grid grid-cols-2 gap-4">
              {guideStats.map((s) => (
                <div key={s.label} className="rounded-md bg-background-50 p-4 text-center">
                  <p className="font-heading text-3xl font-bold text-accent-500">{s.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3 rounded-lg bg-background-100 p-5">
            <div className="flex items-center gap-2">
              <i className="ri-error-warning-line text-primary-500" />
              <p className="text-sm font-semibold text-foreground-950">先别急着信这些</p>
            </div>
            {mythItems.map((m) => (
              <div key={m.myth} className="rounded-md bg-background-50 p-4">
                <p className="text-sm font-semibold text-foreground-800">
                  <span className="mr-1.5 rounded bg-foreground-950/10 px-1.5 py-0.5 text-xs text-primary-700">误区</span>
                  {m.myth}
                </p>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  <span className="mr-1.5 font-semibold text-accent-700">正解</span>
                  {m.truth}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}